var _circle, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaCovarageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white",
    fillOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2167 12H14C13.4477 12 13 12.4477 13 13V28C13 28.5523 13.4477 29 14 29H27C27.5523 29 28 28.5523 28 28V16.7377L23.2167 12Z",
    fill: "url(#paint0_linear_2_14351)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2167 12L23.5686 11.6448C23.4749 11.552 23.3485 11.5 23.2167 11.5V12ZM28 16.7377H28.5C28.5 16.6043 28.4467 16.4764 28.3519 16.3825L28 16.7377ZM14 12.5H23.2167V11.5H14V12.5ZM13.5 13C13.5 12.7239 13.7239 12.5 14 12.5V11.5C13.1716 11.5 12.5 12.1716 12.5 13H13.5ZM13.5 28V13H12.5V28H13.5ZM14 28.5C13.7239 28.5 13.5 28.2761 13.5 28H12.5C12.5 28.8284 13.1716 29.5 14 29.5V28.5ZM27 28.5H14V29.5H27V28.5ZM27.5 28C27.5 28.2761 27.2761 28.5 27 28.5V29.5C27.8284 29.5 28.5 28.8284 28.5 28H27.5ZM27.5 16.7377V28H28.5V16.7377H27.5ZM28.3519 16.3825L23.5686 11.6448L22.8649 12.3552L27.6481 17.093L28.3519 16.3825Z",
    fill: "url(#paint1_linear_2_14351)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2656 17H24V20.7344H23.3776V18.0625L16.4401 25L16 24.5599L22.9375 17.6224H20.2656V17Z",
    fill: "url(#paint2_linear_2_14351)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_14351",
    x1: 20.4375,
    y1: 12,
    x2: 20.4375,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_14351",
    x1: 20.4375,
    y1: 12,
    x2: 20.4375,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_14351",
    x1: 24,
    y1: 17,
    x2: 17.1536,
    y2: 23.8464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575757"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaCovarageIcon);
export default __webpack_public_path__ + "static/media/media_covarage_icon.6e9e148f64711cf7c24def5e5a710612.svg";
export { ForwardRef as ReactComponent };